<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
document.addEventListener("DOMContentLoaded", function () {
  // Select all anchor elements within the footer-block__list
  const links = document.querySelectorAll(".footer-block__list a");

  // Loop through each link and set target attribute to "_blank"
  links.forEach(link => {
    link.setAttribute("target", "_blank");
  });
});


document.addEventListener("DOMContentLoaded", function () {
    // Find the input element by its name attribute
    const inputElement = document.querySelector('input[name="textBox-c7a78438_1732276190497"]');

    if (inputElement) {
        // Create a new select element
        const selectElement = document.createElement("select");
        selectElement.style.fontFamily = "Poppins";
        selectElement.style.fontSize = "12px";
        selectElement.style.color = "rgb(53, 64, 81)";
        selectElement.style.fontWeight = "normal";
        selectElement.style.fontStyle = "normal";
        selectElement.style.borderRadius = "4px";
        selectElement.style.borderWidth = "1px";
        selectElement.style.borderColor = "rgb(190, 198, 202)";
        selectElement.style.backgroundColor = "rgb(255, 255, 255)";
        selectElement.style.width = "100%";

        // Create the two options
        const option1 = document.createElement("option");
        option1.value = "Los Angeles";
        option1.textContent = "Los Angeles";

        const option2 = document.createElement("option");
        option2.value = "San Francisco";
        option2.textContent = "San Francisco";

        // Append options to the select element
        selectElement.appendChild(option1);
        selectElement.appendChild(option2);

        // Replace the input element with the select element
        inputElement.parentNode.replaceChild(selectElement, inputElement);
    }
});

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
